import React, { PureComponent } from "react";
import { Radio, Input, Button, Select, Layout, Checkbox } from 'element-react';
import codeImg from "images/index/job.png";

import 'element-theme-default';
require("./index.css");

//部长信箱
export default class DisciplinaryInspection extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      active: 0,
      radioValue: 1,
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: 1,
      isCheck: false,
      dialogVisible0: false,
      dialogVisible2: false,
      dialogVisible3: false
    }
  }



  check() {
    let { isCheck, } = this.state;
    this.setState({
      isCheck: !isCheck,
    })
  }

  next() {
    this.setState({
        dialogVisible3: true,
      })
  }

  onChange(value) {
    this.setState({ value });
  }

  renderMail() {
    let { isCheck, active } = this.state;
    let isdialogVisible = 'dialogVisible' + active;
    return (
      <div className="content_txt">
        <div>欢迎您访问退役军人事务部“部长信箱”栏目！部长信箱主要用于接收社会公众对我部工作提出的意见和建议。对于共性问题，我们将组织有关单位进行认真研究，不定期在我部网站上作统一公开答复，请您留意。为了方便与您联系，请您务必留下真实的联系方式。感谢您对退役军人事务部工作的关注和支持！</div>
        <div>来信前请您务必阅读以下条款</div>
        <div>一、遵守中华人民共和国宪法和法律、相关法规，承担一切因您的不当言论引起的法律责任；</div>
        <div>二、尊重网上道德，请勿发表未经证实的消息和造谣、诽谤他人的言论;</div>
        <div>三、所提意见、建议须与退役军人工作直接相关；</div>
        <div>四、举报违法违纪线索请通过“纪检监察举报”栏目办理；</div>
        <div>五、反映个人利益诉求请通过“网上信访”栏目办理；</div>
        <div>六、请务必准确填写自己的真实姓名、身份证号码、联系电话和通讯地址，否则不予受理。</div>
        <div className="affirm_box"><Checkbox checked={isCheck} onChange={() => this.check(this)}>我已阅读以上内容，并同意遵守</Checkbox></div>
        <div className="next_box"><Button type="primary" disabled={!isCheck} className="next_btn" onClick={() => this.next()} >下一步</Button></div>
      </div>
    )
  }

  renderReportForm() {
    return (
      <form >
        <div className="table">
          <Layout.Row type="flex" className="row-bg title">
            <Layout.Col span="24">举报人信息（注意：标有<i className="red_star">*</i>的必须填写）</Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">姓名<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="8"><Input className="w250" placeholder="请输入姓名" /></Layout.Col>
            <Layout.Col span="4" className="left">身份证号<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="8">
              <Input className="w250" placeholder="请输入18位身份证号" />
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">联系电话<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="8"><Input className="w250" placeholder="请输入联系电话" /></Layout.Col>
            <Layout.Col span="4" className="left">电子邮箱<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="8">
              <Input className="w250" placeholder="请输入电子邮箱" />
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">政治面貌<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="8">
              <Select value={this.state.value} placeholder="请选择" className="w250">
                {
                  this.state.options.map(el => {
                    return <Select.Option key={el.value} label={el.label} value={el.value} />
                  })
                }
              </Select>
            </Layout.Col>
            <Layout.Col span="4" className="left">举报人职级<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="8">
              <Input className="w250" placeholder="请输入职级" />
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">现居住地址<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="20">
              <Input placeholder="请输入现居住地址" className="w675" />
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg title">
            <Layout.Col span="24">被举报人（单位）信息（注意：标有<i className="red_star">*</i>的必须填写）</Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">被举报人<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="8">
              <Input placeholder="请输入被举报人姓名" className="w250" />
            </Layout.Col>
            <Layout.Col span="4" className="left">被举报人部门<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="8">
              <Select value={this.state.value} placeholder="请选择" className="w250">
                {
                  this.state.options.map(el => {
                    return <Select.Option key={el.value} label={el.label} value={el.value} />
                  })
                }
              </Select>
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">被举报人职务<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="8">
              <Input placeholder="请输入被举报人职务" className="w250" />
            </Layout.Col>
            <Layout.Col span="4" className="left">被举报人职级<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="8">
              <Select value={this.state.value} placeholder="请选择" className="w250">
                {
                  this.state.options.map(el => {
                    return <Select.Option key={el.value} label={el.label} value={el.value} />
                  })
                }
              </Select>
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg title">
            <Layout.Col span="24">举报正文（注意：标有<i className="red_star">*</i>的必须填写）</Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">标题<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="20">
              <Input placeholder="不超过30字" maxLength="30" className="w675" />
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">问题类别<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="20">
              <Select value={this.state.value} placeholder="请选择" className="w675">
                {
                  this.state.options.map(el => {
                    return <Select.Option key={el.value} label={el.label} value={el.value} />
                  })
                }
              </Select>
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">问题细类<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="20">
              <Select value={this.state.value} placeholder="请选择" className="w675">
                {
                  this.state.options.map(el => {
                    return <Select.Option key={el.value} label={el.label} value={el.value} />
                  })
                }
              </Select>
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">内容<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="20">
              <Input
                type="textarea"
                autosize={{ minRows: 6 }}
                placeholder="不超过1000字"
                className="textarea"
              />
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">验证码<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="20">
              <Input className="w160 float_l" placeholder="请输入手机号码" />
              <img className="code_img float_l" src={codeImg} />
              <span className="change">看不清，换一张</span>
            </Layout.Col>
          </Layout.Row>
        </div>
        <div className="submit_box">
          <button type="button" className="submit_btn">提交</button>
        </div>
      </form>
    )
  }


  render() {
    let {  dialogVisible3 } = this.state;

    return (
      <div className="content_list">
        {!dialogVisible3 ? this.renderMail() : dialogVisible3 ? this.renderReportForm() : null}
     
      </div>
    );
  }
}
